import { Modal, Button, Typography } from "antd";
const { Title, Text } = Typography;

export default function LocationRequiredModal({
    showLocationModal,
    setShowLocationModal
}) {
  return (
    <Modal
        visible={showLocationModal}
        onCancel={() => setShowLocationModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowLocationModal(false)}>
            Cancel
          </Button>,
        ]}
        title="Location Access Required"
      >
        <Text>
          This app needs your location to show nearby queues. Please allow
          location access to continue.
        </Text>
      </Modal>
  );
}